import initialState from './initialState';
import {
  SUPERVISOR_REVISION_PANEL_GET_PERIODS_LIST_INIT,
  SUPERVISOR_REVISION_PANEL_GET_PERIODS_LIST_SUCCESS,
  SUPERVISOR_REVISION_PANEL_GET_PERIODS_LIST_FAILURE,
  SUPERVISOR_REVISION_PANEL_GET_REVISIONS_LIST_INIT,
  SUPERVISOR_REVISION_PANEL_GET_REVISIONS_LIST_SUCCESS,
  SUPERVISOR_REVISION_PANEL_GET_REVISIONS_LIST_FAILURE,
  SUPERVISOR_REVISION_PANEL_GET_ALL_SUPERVISORS_REVISIONS_INIT,
  SUPERVISOR_REVISION_PANEL_GET_ALL_SUPERVISORS_REVISIONS_SUCCESS,
  SUPERVISOR_REVISION_PANEL_GET_ALL_SUPERVISORS_REVISIONS_FAILURE,  
  SUPERVISOR_REVISION_PANEL_GET_SUPERVISOR_MODEL_REVISION_HISTORY_INIT,
  SUPERVISOR_REVISION_PANEL_GET_SUPERVISOR_MODEL_REVISION_HISTORY_SUCCESS,
  SUPERVISOR_REVISION_PANEL_GET_SUPERVISOR_MODEL_REVISION_HISTORY_FAILURE,
  SUPERVISOR_REVISION_PANEL_GET_MODELS_LIST_INIT,
  SUPERVISOR_REVISION_PANEL_GET_MODELS_LIST_SUCCESS,
  SUPERVISOR_REVISION_PANEL_GET_MODELS_LIST_FAILURE,
  SUPERVISOR_REVISION_PANEL_SET_REVISION_STATUS_INIT,
  SUPERVISOR_REVISION_PANEL_SET_REVISION_STATUS_SUCCESS,
  SUPERVISOR_REVISION_PANEL_SET_REVISION_STATUS_FAILURE,
  SUPERVISOR_REVISION_PANEL_DOWNLOAD_REVISION_INIT,
  SUPERVISOR_REVISION_PANEL_DOWNLOAD_REVISION_SUCCESS,
  SUPERVISOR_REVISION_PANEL_DOWNLOAD_REVISION_FAILURE,
  SUPERVISOR_REVISION_PANEL_SET_PERIOD_ID,
  SUPERVISOR_REVISION_PANEL_SOFT_RESET,
  SUPERVISOR_REVISION_PANEL_RESET,
} from '../../actions/supervisorRevisionPanel/types';
import ReducersTooling from '../../../tooling/reducersTooling';

export default function supervisorRevisionAdmin(state = initialState, action) {
  switch (action.type) {
    case SUPERVISOR_REVISION_PANEL_GET_PERIODS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "periodsList");
    case SUPERVISOR_REVISION_PANEL_GET_PERIODS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "periodsList");
    case SUPERVISOR_REVISION_PANEL_GET_PERIODS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "periodsList");

    case SUPERVISOR_REVISION_PANEL_GET_REVISIONS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "revisionsList");
    case SUPERVISOR_REVISION_PANEL_GET_REVISIONS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "revisionsList");
    case SUPERVISOR_REVISION_PANEL_GET_REVISIONS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "revisionsList");

    case SUPERVISOR_REVISION_PANEL_GET_ALL_SUPERVISORS_REVISIONS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "allSupervisorsRevisionsList");
    case SUPERVISOR_REVISION_PANEL_GET_ALL_SUPERVISORS_REVISIONS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "allSupervisorsRevisionsList");
    case SUPERVISOR_REVISION_PANEL_GET_ALL_SUPERVISORS_REVISIONS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "allSupervisorsRevisionsList");

    case SUPERVISOR_REVISION_PANEL_GET_SUPERVISOR_MODEL_REVISION_HISTORY_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "supervisorModelRevisionHistory");
    case SUPERVISOR_REVISION_PANEL_GET_SUPERVISOR_MODEL_REVISION_HISTORY_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "supervisorModelRevisionHistory");
    case SUPERVISOR_REVISION_PANEL_GET_SUPERVISOR_MODEL_REVISION_HISTORY_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "supervisorModelRevisionHistory");

    case SUPERVISOR_REVISION_PANEL_GET_MODELS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "modelsList");
    case SUPERVISOR_REVISION_PANEL_GET_MODELS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "modelsList");
    case SUPERVISOR_REVISION_PANEL_GET_MODELS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "modelsList");  

    case SUPERVISOR_REVISION_PANEL_SET_REVISION_STATUS_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "setRevisionStatus");
    case SUPERVISOR_REVISION_PANEL_SET_REVISION_STATUS_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "setRevisionStatus");
    case SUPERVISOR_REVISION_PANEL_SET_REVISION_STATUS_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "setRevisionStatus");

    case SUPERVISOR_REVISION_PANEL_DOWNLOAD_REVISION_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "downloadRevision");
    case SUPERVISOR_REVISION_PANEL_DOWNLOAD_REVISION_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "downloadRevision");
    case SUPERVISOR_REVISION_PANEL_DOWNLOAD_REVISION_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "downloadRevision");
      
    case SUPERVISOR_REVISION_PANEL_SET_PERIOD_ID:
    return {
      ...state,
      periodId: action.id
    };
      
    case SUPERVISOR_REVISION_PANEL_SOFT_RESET:
      return {
        ...initialState,
        periodsList: state.periodsList,
        periodId: state.periodId,
      };  

    case SUPERVISOR_REVISION_PANEL_RESET:
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/supervisorRevisionPanel/index.js